import { render, staticRenderFns } from "./FixSmsMaintenance.vue?vue&type=template&id=64f1402a&scoped=true"
import script from "./FixSmsMaintenance.vue?vue&type=script&lang=js"
export * from "./FixSmsMaintenance.vue?vue&type=script&lang=js"
import style0 from "./FixSmsMaintenance.vue?vue&type=style&index=0&id=64f1402a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1402a",
  null
  
)

export default component.exports